import { Stack, Typography } from '@mui/material'
import { ExpertiseMeeting } from '@/core/models/expertise-meeting.model'
import { QuitMeetingButton } from './QuitMeetingButton'
import { CopyLinkButton } from './CopyLinkButton'

type MeetingToolbarContentProps = {
  expertiseMeeting: ExpertiseMeeting
}

export function MeetingToolbarContent({ expertiseMeeting }: MeetingToolbarContentProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={2} width="100%">
      <Typography component="h1">{expertiseMeeting.title}</Typography>
      <Stack direction="row" flex={1} justifyContent="flex-end" spacing={1}>
        <CopyLinkButton expertiseMeetingId={expertiseMeeting._id} />
      </Stack>
      <QuitMeetingButton />
    </Stack>
  )
}
